/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 16:49:55
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/avatarGroup.js
 */
export default {
    // avatarGroup 组件
    avatarGroup: {
        urls: [],
        maxCount: 5,
        shape: 'circle',
        mode: 'scaleToFill',
        showMore: true,
        size: 40,
        keyName: '',
        gap: 0.5,
		extraValue: 0
    }
}
